// src/pages/Admin/Users/AddUserModal.jsx
import React, { useState } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import Button from "../../../components/Button/Button";
import { addUserByAdmin } from "../../../services/userServices";
import { useUser } from "../../Home/UserContext";
import { getRoleFromRoleId } from "../../../utils/roleHelper";
import { toast } from "react-toastify";

const AddUserModal = ({ isOpen, onClose, refreshList }) => {
  const { user } = useUser();
  // role non utilisé ici mais conservé si besoin d'ACL plus tard
  const userRole = getRoleFromRoleId(user?.role_id);

  const [userData, setUserData] = useState({
    nom: "",
    prenom: "",
    email: "",
    role_id: "",
    metier: "", // Ajout du champ métier
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: name === "role_id" ? parseInt(value, 10) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addUserByAdmin(userData);
      toast.success("Utilisateur créé avec succès");
      refreshList?.();
      onClose?.();
      setUserData({ nom: "", prenom: "", email: "", role_id: "", metier: "" });
    } catch (error) {
      console.error("Erreur création utilisateur:", error);
      toast.error("Erreur lors de la création de l'utilisateur");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden
      />

      {/* Modal */}
      <div className="relative w-full max-w-md overflow-hidden rounded-2xl shadow-2xl bg-white dark:bg-slate-900 ring-1 ring-slate-200/70 dark:ring-slate-700/70">
        {/* Header dégradé */}
        <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500 px-5 py-4">
          <h3 className="text-white text-lg sm:text-xl font-bold text-center uppercase">
            Ajouter un utilisateur
          </h3>
          <p className="text-white/90 text-center text-xs mt-1">
            Renseignez les informations ci-dessous.
          </p>
        </div>

        {/* Contenu */}
        <form onSubmit={handleSubmit} className="p-5 sm:p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
              Nom
            </label>
            <input
              type="text"
              name="nom"
              value={userData.nom}
              onChange={handleChange}
              required
              className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
              Prénom
            </label>
            <input
              type="text"
              name="prenom"
              value={userData.prenom}
              onChange={handleChange}
              required
              className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={userData.email}
              onChange={handleChange}
              required
              className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
              Métier
            </label>
            <input
              type="text"
              name="metier"
              value={userData.metier}
              onChange={handleChange}
              className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
              Rôle
            </label>
            <select
              name="role_id"
              value={userData.role_id}
              onChange={handleChange}
              required
              className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
            >
              <option value="">Sélectionner un rôle</option>
              <option value="1">Administrateur</option>
              <option value="2">Utilisateur</option>
              <option value="3">Enseignant</option>
            </select>
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-2 pt-2">
            <Button
              text="Fermer"
              icon={FaTimes}
              type="button"
              onClick={onClose}
              className="!bg-slate-100 !text-slate-800 hover:!bg-slate-200 dark:!bg-slate-800 dark:!text-slate-100 dark:hover:!bg-slate-700 !rounded-xl gap-2"
            />
            <Button
              text="Créer"
              icon={FaSave}
              type="submit"
              className="!rounded-xl gap-2"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
